export const appsUserInfoScheduledMergeDuplicateUsersRules =
  "/apps/user_info/scheduled_merge_duplicate_users_rules";
